import React from 'react';
import styled, { keyframes } from 'styled-components';

const drift = keyframes`
  0%, 100% {
    opacity: 0.4;
    transform: translate(0, 0) scale(1);
  }
  33% {
    opacity: 0.6;
    transform: translate(30px, -20px) scale(1.05);
  }
  66% {
    opacity: 0.35;
    transform: translate(-20px, 10px) scale(0.98);
  }
`;

const drift2 = keyframes`
  0%, 100% {
    opacity: 0.25;
    transform: translate(0, 0) scale(1);
  }
  50% {
    opacity: 0.4;
    transform: translate(-40px, 20px) scale(1.08);
  }
`;

const GlowContainer = styled.div`
  position: absolute;
  inset: -200px -100px;
  pointer-events: none;
  overflow: hidden;
  z-index: 0;
`;

const Orb = styled.div`
  position: absolute;
  border-radius: 50%;
  filter: blur(100px);
`;

const OrbPrimary = styled(Orb)`
  width: 600px;
  height: 600px;
  top: -200px;
  left: 50%;
  margin-left: -300px;
  background: radial-gradient(circle, rgba(16, 171, 255, 0.12) 0%, transparent 70%);
  animation: ${drift} 12s ease-in-out infinite;
`;

const OrbSecondary = styled(Orb)`
  width: 400px;
  height: 400px;
  top: -100px;
  right: 15%;
  background: radial-gradient(circle, rgba(16, 171, 255, 0.08) 0%, transparent 70%);
  animation: ${drift2} 16s ease-in-out infinite;
`;

const OrbTertiary = styled(Orb)`
  width: 300px;
  height: 300px;
  top: 50px;
  left: 20%;
  background: radial-gradient(circle, rgba(142, 137, 255, 0.06) 0%, transparent 70%);
  animation: ${drift} 20s ease-in-out infinite reverse;
`;

export default function GlowBackground() {
  return (
    <GlowContainer>
      <OrbPrimary />
      <OrbSecondary />
      <OrbTertiary />
    </GlowContainer>
  );
}
